import React from 'react';
class ReferralSetup extends React.Component {
  render() {
    return <div>This is Referral setup</div>;
  }
}
export default ReferralSetup;
